import { createSimpleStore } from '@passionware/simple-store';
import { isEqual } from 'lodash';
import { useLayoutEffect, useState } from 'react';

/**
 * A store made once and kept equal to the latest `value`: what an object built once (a
 * controller's hooks) reads inside, so what changes under it reaches it without a new object.
 * A host builds `value` anew on every render, so only one that differs by value is set.
 */
export function useSimpleStoreFromValue<T>(value: T) {
  const [store] = useState(() => createSimpleStore(value));
  useLayoutEffect(() => {
    if (!isEqual(store.getCurrentValue(), value)) store.setNewValue(value);
  }, [store, value]);
  return store;
}
